export {MyProfileModule} from './MyProfileModule';
